module.exports = __webpack_public_path__ + "static/media/logo.507a1494.svg";